// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3PAIL","log":"ModalInventoryLogs_log__yi4L7","date":"ModalInventoryLogs_date__2bhUv","userName":"ModalInventoryLogs_userName__16di8"};